import { $getRoot, $insertNodes, EditorState, LexicalEditor } from 'lexical';
import { useEffect, useState } from 'react';
import { ToolbarPlugin } from './plugins/ToolbarPlugin';
import { $generateHtmlFromNodes, $generateNodesFromDOM } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
// import { TreeView } from '@lexical/react/LexicalTreeView';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { CheckListPlugin } from '@lexical/react/LexicalCheckListPlugin';
// import { ListPlugin } from '@lexical/react/LexicalListPlugin';
// import { TablePlugin } from '@lexical/react/LexicalTablePlugin';
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin';

import DraggableBlockPlugin from './plugins/DraggableBlockPlugin';
import FloatingTextFormatToolbarPlugin from './plugins/FloatingTextFormatToolbarPlugin';
import { TypographyStyled } from './TypographyStyled';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import LinkPlugin from './plugins/LinkPlugin';
import FloatingLinkEditorPlugin from './plugins/FloatingLinkEditorPlugin';
import AutoLinkPlugin from './plugins/AutoLinkPlugin';
import Placeholder from './ui/Placeholder';
// import {useSharedHistoryContext} from './context/SharedHistoryContext';

export type EditorProps = {
  initialValue?: string;
  onChange?: (value: string) => void;
};
export const Editor = ({ initialValue, onChange }: EditorProps) => {
  const [editor] = useLexicalComposerContext();
  // const {historyState} = useSharedHistoryContext();
  const [floatingAnchorElem, setFloatingAnchorElem] =
    useState<HTMLDivElement | null>(null);
  const onRef = (_floatingAnchorElem: HTMLDivElement) => {
    if (_floatingAnchorElem !== null) {
      setFloatingAnchorElem(_floatingAnchorElem);
    }
  };
  const handleChange = (
    _editorState: EditorState,
    editor: LexicalEditor,
    _tags: Set<string>,
  ) => {
    editor.update(() => {
      const htmlString = $generateHtmlFromNodes(editor, null);
      onChange?.(htmlString);
    });
  };

  // init default value
  useEffect(() => {
    editor.update(() => {
      const parser = new DOMParser();
      const dom = parser.parseFromString(initialValue || '', 'text/html');
      const nodes = $generateNodesFromDOM(editor, dom);

      $getRoot().clear(); // fix append content
      $getRoot().select();

      $insertNodes(nodes);
    });
  }, [initialValue, editor]);

  return (
    <TypographyStyled>
      <OnChangePlugin onChange={handleChange} />

      <div className="editor">
        <ToolbarPlugin />
        {floatingAnchorElem && (
          <>
            <DraggableBlockPlugin anchorElem={floatingAnchorElem} />
            <FloatingTextFormatToolbarPlugin anchorElem={floatingAnchorElem} />
            <FloatingLinkEditorPlugin anchorElem={floatingAnchorElem} />
          </>
        )}
        <div className="editor-container">
          <RichTextPlugin
            contentEditable={
              <div className="editor-scroller">
                <div className="editor-body" ref={onRef}>
                  <ContentEditable className="content-editable" />
                </div>
              </div>
            }
            placeholder={<Placeholder>Nhập nội dung...</Placeholder>}
            ErrorBoundary={LexicalErrorBoundary}
          />
        </div>
        <HistoryPlugin />

        <AutoLinkPlugin />
        <LinkPlugin />
        <LinkPlugin />
        <CheckListPlugin />
      </div>
      {/* <TreeView */}
      {/*   viewClassName="tree-view-output" */}
      {/*   timeTravelPanelClassName="debug-timetravel-panel" */}
      {/*   timeTravelButtonClassName="debug-timetravel-button" */}
      {/*   timeTravelPanelSliderClassName="debug-timetravel-panel-slider" */}
      {/*   timeTravelPanelButtonClassName="debug-timetravel-panel-button" */}
      {/*   treeTypeButtonClassName="" */}
      {/*   editor={editor} */}
      {/* /> */}
    </TypographyStyled>
  );
};
